/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Category of cost metadata. Determines which additional fields are populated. - DATA_TRANSFER: operationType field is present 
*/
export enum CostRecordMetadataType {
  DataTransfer = 'DATA_TRANSFER'
}
